// Photos from https://citizenofnowhe.re/lines-of-the-city
import { Fragment, useEffect, useRef, useState } from "react";
import NavbarComponent from "../component/PageComponents/NavbarComponent";
import Landing from "../component/PageComponents/Landing";
import AppKarmaSection from "../component/PageComponents/AppKarmaSection";
import AffiliateProgramInfo from "../component/PageComponents/AffiliateProgramInfo";
import Contact from "../component/PageComponents/Contact";
import Footer from '../component/PageComponents/Footer';
import { Outlet, matchPath, useLocation } from 'react-router-dom';
import CashKarmaSection from '../component/PageComponents/CashKarmaSection';

export default function MomoKarmaPage() {
  const [selectedTopic, setSelectedTopic] = useState({
    type: true,
    key: 'Choose A Topic',
    label: 'Choose A Topic',
    // labelColor: "#9BDEDC",
    // details: "Choose a topic",
  })
  const landingRef = useRef(null);
  const appKarmaRef = useRef(null);
  const cashKarmaRef = useRef(null);
  const affiliateProgramRef = useRef(null);
  const contactRef = useRef(null);

  const location = useLocation();
  const [selectedPage, setSelectedPage] = useState("");

  useEffect(() => {
    setSelectedPage(location.hash);
    const hash = location.hash;
    // If there is a hash and it matches the ID of the target component
    if ((hash && hash === '#landing_page')) {
      // Scroll to the component using the DOM method
      landingRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
    else if (hash && hash === '#appkarma_page') {
      // Scroll to the component using the DOM method
      appKarmaRef.current?.scrollIntoView({ behavior: 'smooth' });
    } else if (hash && hash === '#cashkarma_page') {
      // Scroll to the component using the DOM method
      cashKarmaRef.current?.scrollIntoView({ behavior: 'smooth' });
    } else if (hash && hash === '#affiliate_program_page') {
      // Scroll to the component using the DOM method
      affiliateProgramRef.current?.scrollIntoView({ behavior: 'smooth' });
    } else if (hash && hash === '#contact_page') {
      // Scroll to the component using the DOM method
      contactRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location])

  return (
    <div>
      <div className="font-base">
        <div className="bg-white-100 w-screen fixed z-50">
          <NavbarComponent
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            appRef={[appKarmaRef, cashKarmaRef]}
          />
        </div>
        <div className="snap-y snap-mandatory h-screen overflow-scroll">
          {
            matchPath("/legal/terms", location.pathname) || matchPath("/legal/privacy", location.pathname) ? <Outlet /> : <Fragment>
              <Landing landingRef={landingRef} />
              <AppKarmaSection appKarmaRef={appKarmaRef} />
              <CashKarmaSection cashKarmaRef={cashKarmaRef} />
              <AffiliateProgramInfo affiliateProgramRef={affiliateProgramRef} setSelectedTopic={setSelectedTopic} />
              {/* <Contact contactRef={contactRef} selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic} /> */}
            </Fragment>
          }
        </div>
        <Footer />
      </div>
    </div >
  );
}
